// Orchestrates Azure SSO login flow. If already logged in, signs out first to avoid Amplify UserAlreadyAuthenticatedException
export const azureSsoFlow = async ({ isLoggedIn, signOutFn, signInWithRedirectFn }) => {
  if (isLoggedIn) {
    await signOutFn();
  }
  await signInWithRedirectFn({ provider: { custom: 'Acuity-Azure' } });
};
